import { createConnectQueryKey, useMutation, useQuery } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import {
  getControlStatusCommentSetting,
  setControlStatusCommentSetting,
} from '@/gen/inventory/v1/control_service-ControlInventoryService_connectquery'

import { defaultTransport } from '@/lib/connect/connect-transport'

const getControlStatusCommentSettingQueryKey = () =>
  createConnectQueryKey({
    schema: getControlStatusCommentSetting,
    input: {},
    cardinality: 'finite',
    transport: defaultTransport,
  })

export const useGetControlStatusCommentSetting = ({ enabled = true } = {}) => {
  const queryState = useQuery(getControlStatusCommentSetting, {}, { enabled })

  return {
    ...queryState,
    setting: queryState.data?.setting,
  }
}

export const useIsControlCommentRequired = ({ enabled = true } = {}) =>
  useGetControlStatusCommentSetting({ enabled }).setting?.requireCommentOnStatusChange ?? false

export const useSetControlStatusCommentSetting = () => {
  const queryClient = useQueryClient()

  return useMutation(setControlStatusCommentSetting, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getControlStatusCommentSettingQueryKey() })
    },
  })
}
